import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import {Provider} from "react-redux";
import BidderRootCmp from "./components/bidder/BidderRootCmp";
import {WebcastAuctionConnectData_TypeDef} from "@nextlot/core/webcast/services/AuctionsManager";
import {DataStore} from "@nextlot/core/webcast";
import AuctionsManager from "@nextlot/core/webcast/services/AuctionsManager";
import {NextLotJSDATA_TypeDef} from "@nextlot/core/NextLotJSDATA";
import './i18n';


export function load(appConfigData:NextLotJSDATA_TypeDef, webcastAuctionConnectData:WebcastAuctionConnectData_TypeDef) {
    console.log('NLWebcast: --- loading BIDDER screen: ', webcastAuctionConnectData);

    const el_cmp_RootCmp = document.getElementById('cmp_RootCmp');
    if (el_cmp_RootCmp) {

        DataStore.init(appConfigData);

        AuctionsManager.init(DataStore.reduxStore);

        AuctionsManager.createWebcastAuctionHandler(webcastAuctionConnectData);

        ReactDOM.createRoot(el_cmp_RootCmp!)
            .render(
                <Provider store={DataStore.reduxStore}>
                    <Suspense fallback="loading">
                        <BidderRootCmp />
                    </Suspense>
                </Provider>
            );

    }
    else {
        alert('Fatal error: HTML DOM element `#cmp_RootCmp` not found!');
        throw 'HTML DOM element cmp_RootCmp not found.';
    }

}
